import { HeaderSection } from 'components/HeaderSection/HeaderSection';
import s from './Support.module.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Brush } from "assets/icons/brush.svg";
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Tabs } from 'components/Tabs/Tabs';
import { Chats } from './components/Chats/Chats';
import { Route, Routes } from 'react-router-dom';
import { Chat } from './components/Chat/Chat';
import { SupportSettings } from './components/SupportSettings/SupportSettings';
import { CreateDefaultMessage } from './components/SupportSettings/CreateMessage/CreateDefaultMessage';

export const Support = () => {

    // ### State
    const [containerHeight, setContainerHeight] = useState<any>(1000)

    const {t} = useTranslation()
    const wrapperRef = useRef<HTMLDivElement>(null)


    const items = [
        {
            id: 0,
            title: t('support.chats'),
            path: "/support"
        },
        {
            id: 1,
            title: t('general.settings'),
            path: "/support/settings"
        }
    ]

    const [tab, setTab] = useState(items[0]?.id)

    // ### Effects
    useEffect(()=>{
        if(window.location.href?.includes('support/settings')) setTab(1)
    },[]);

    // ### Functions
    
    // ### Views
    return(
        <div className={s.dashboard}>
            <div className={s.tabs_wrapper}>
                <Tabs
                    items={items}
                    tab={tab}
                    setTab={setTab}
                />
            </div>

            <div className={s.wrapper}>
                <Routes>
                    <Route path="/" element={<Chats />} />
                    <Route path="/settings" element={<SupportSettings/>} />
                    <Route path="/settings/create/" element={<CreateDefaultMessage/>} />
                    <Route path="/settings/create/:id" element={<CreateDefaultMessage/>} />
                </Routes>
            </div>
        </div>
    )
}